<template>
  <MinusCircle custom-style="h-4 w-4 text-white" />
</template>

<script>
export default {
  name: 'MinusCircleSmall',
  props: {
    bgColor: {
      type: String,
      default: 'bg-green-600',
    },
  },
}
</script>
